import { Box, Text, Alert, Columns, Column } from 'braid-design-system';
import React, { type ReactNode } from 'react';

type SelectAdTypeErrorProps = {
  children: ReactNode;
  marginBottom?: 'small' | 'medium' | 'large';
  tone?: 'critical' | 'info';
};

export const SelectAdTypeError = ({
  children,
  marginBottom,
  tone = 'critical',
}: SelectAdTypeErrorProps) => (
  <Box marginBottom={marginBottom}>
    <Columns space="none" collapseBelow="tablet">
      <Column width="2/3">
        <Alert tone={tone}>
          <Text>{children}</Text>
        </Alert>
      </Column>
    </Columns>
  </Box>
);
